// extracted by mini-css-extract-plugin
export default {"MultiChoiceInput":"styles_MultiChoiceInput__a7Rqb","input":"styles_input__AIwks","checkbox":"styles_checkbox__Vbxhj","checkboxIcon":"styles_checkboxIcon__0Ur38"};